import RewardNewspaper from './RewardNewspaper'

export default RewardNewspaper
